import React from 'react'
const Expires = (props) => {
    var date = new Date();
    let dateFinal = date.toISOString()
    let expire = (Math.round((new Date(props.expiryDate) - new Date(dateFinal)) / (1000 * 3600 * 24)))
    const isExpired = expire < 1
    const isExpiringSoon = !isExpired && expire <= 30

    return (
        <div className="connector-meta-col">
            <p className="connector-meta-label">Status</p>
            <div className="connector-meta-value">
                {
                    isExpired
                        ? <span className="connector-meta-badge connector-meta-badge-danger">Expired</span>
                        : isExpiringSoon
                            ? <span className="connector-meta-badge connector-meta-badge-warning">{expire} days</span>
                            : props.showActiveBadge
                                ? <span className="connector-meta-badge connector-meta-badge-success" title={`${expire} days remaining`}>Active</span>
                                : <span>{expire} days</span>
                }
            </div>
        </div>
    )
}
export default Expires
